import ReactGA from 'react-ga'

export default (path: string) => {
  if (!process.env.REACT_APP_GOOGLE_ANALYTICS_UID) return null

  ReactGA.set({ page: path })
  ReactGA.pageview(path)
}
